import { createRouter, createWebHistory } from "vue-router";
import HomePage from "../views/HomePage.vue";
import { useAuthStore } from "@/store/auth";

// ⭐️ 여정(발견) 페이지 임시 로드 (추후 실제 views/JourneyPage.vue 생성 시 교체)
const JourneyPage = () => import("../views/JourneyPage.vue");

function updateMetaTags(title, description) {
  document.title = title;
  let descriptionTag = document.querySelector('meta[name="description"]');
  if (!descriptionTag) {
    descriptionTag = document.createElement("meta");
    descriptionTag.setAttribute("name", "description");
    document.head.appendChild(descriptionTag);
  }
  descriptionTag.setAttribute("content", description);
}

const routes = [
  // 1. 메인 (홈)
  {
    path: "/",
    name: "HomePage",
    component: HomePage,
    meta: {
      title: "말로만랩 - 지식 탐험의 시작",
      description:
        "AI 기반 지식 탐험 플랫폼 말로만랩. 상상을 현실로 만드는 창의적 여정을 시작하세요.",
    },
  },

  // 2. 탐험 (Explore)
  {
    path: "/journey",
    name: "JourneyPage",
    component: JourneyPage,
    meta: {
      title: "여정 - 말로만랩",
      description:
        "AI가 실시간으로 생성하는 연관 주제를 따라 떠나는 끝없는 지식의 파도. 검색창을 넘어선 발견의 즐거움을 느껴보세요.",
    },
  },
  {
    path: "/mining",
    name: "MiningPage",
    component: () => import("../views/MiningPage.vue"),
    meta: {
      title: "누리 - 말로만랩",
      description:
        "방대한 정보 속 핵심만 엄선한 200자 지식 피드. 검증된 알짜 지식들을 가볍게 산책하듯 즐기세요.",
    },
  },
  {
    path: "/favorites",
    name: "FavoritesPage",
    component: () => import("../views/FavoritesPage.vue"),
    meta: {
      title: "갈무리 - 말로만랩",
      description:
        "영감과 지식을 저장하여 지적 자산을 쌓는 나만의 디지털 서재. 놓치기 아까운 인사이트를 갈무리하세요.",
    },
  },
  {
    path: "/search",
    name: "SearchPage",
    component: () => import("../views/SearchPage.vue"),
    meta: {
      title: "검색 - 말로만랩",
      description: "말로만랩의 방대한 지식 콘텐츠를 검색하고 탐험하세요.",
    },
  },

  // 3. 경험 (Experience)
  {
    path: "/quiz",
    name: "QuizPage",
    component: () => import("../views/QuizPage.vue"),
    meta: {
      title: "슬기 - 말로만랩",
      description:
        "지혜를 증명하는 시간. 다양한 난이도의 퀴즈를 풀며 당신의 지식 이해도를 점검하세요.",
    },
  },
  {
    path: "/speedquiz",
    name: "SpeedQuizPage",
    component: () => import("../views/SpeedQuizPage.vue"),
    meta: {
      title: "재치 - 말로만랩",
      description:
        "찰나의 승부! 순발력과 직관을 테스트하는 실시간 스피드 퀴즈 챌린지.",
    },
  },
  // ⭐️ [신규] 스크래치 게임 추가
  {
    path: "/scratch",
    name: "ScratchGamePage",
    component: () => import("../views/ScratchGame.vue"),
    meta: {
      title: "야금 - 말로만랩",
      description: "지식의 은박을 야금야금 벗겨내며 정답을 유추하세요. 힌트를 덜 볼수록 보상이 커집니다!",
    },
  },

// ⭐️ [수정/이동] 페르소나 -> 실마리
  {
    path: "/silmari",
    name: "SilmariGamePage",
    component: () => import("../views/SilmariGame.vue"),
    meta: {
      title: "실마리 - 말로만랩",
      description: "20명의 요원들이 던져주는 파편화된 실마리를 조합해 감춰진 정답을 유추해내세요.",
    },
  },
  {
    path: "/ranking",
    name: "RankingPage",
    component: () => import("../views/RankingPage.vue"),
    meta: {
      title: "으뜸 - 말로만랩",
      description:
        "퀴즈 명예의 전당. 최고의 지식 탐험가들이 기록한 랭킹과 점수를 확인하세요.",
    },
  },

  {
    path: "/mystery",
    name: "MysteryGamePage",
    component: () => import("../views/MysteryGame.vue"),
    meta: {
      title: "추리사건의 전말 - 말로만랩",
      description: "감춰진 진실을 밝혀내는 AI 미스터리 추리 게임입니다.",
    },
  },
  {
    path: "/receipt",
    name: "ReceiptPage",
    component: () => import("../views/ReceiptPage.vue"),
    meta: {
      title: "욕망의 편의점 - 말로만랩",
      description:
        "그저 요즘 가장 갈망하는 것 3가지만 고르면 됩니다. 나머지는 AI가 알아서 계산합니다.",
    },
  },
  {
    path: "/award",
    name: "AwardPage",
    component: () => import("../views/AwardPage.vue"), 
    meta: {
      title: "뻔뻔한 위원회 - 말로만랩",
      description:
        "숨만 쉬어도 상을 드립니다. 당신의 사소한 일상을 위대한 업적으로 날조하여 고퀄리티 상장을 수여합니다.",
    },
  },
  {
    path: "/chimpanzee",
    name: "ChimpanzeePage",
    component: () => import("../views/ChimpanzeePage.vue"), 
    meta: {
      title: "침팬지보다 낫겠지 - 말로만랩",
      description: "당신의 직관은 침팬지보다 빠릅니까? 찰나의 순간을 기억하는 기억력 테스트.",
    },
  },
  {
    path: "/physical-exam",
    component: () => import("../views/PhysicalExamPage.vue"), 
    name: "PhysicalExamPage",
    meta: {
      title: "디지털 신체검사 - 말로만랩",
      description: "길이, 각도, 색감, 정확도, 시간. 당신의 디지털 감각 나이를 측정해보세요.",
    },
  },
  // ⭐️ [추가] 그걸 못 맞춰? (라우터 추가)
  {
    path: "/cant-match",
    name: "CantMatchThisPage",
    component: () => import("../views/CantMatchThisPage.vue"),
    meta: {
      title: "그걸 못 맞춰? - 말로만랩",
      description: "당신의 동체시력과 리듬감을 테스트해보세요. 오차 0px에 도전하는 인간 144Hz 판별기.",
    },
  },
  {
    path: "/math-give-up",
    name: "MathGiveUpPage",
    component: () => import("../views/MathGiveUpPage.vue"),
    meta: {
      title: "수포자 5초 전 - 말로만랩",
      description: "당신은 수학을 포기하셨습니까? 단 5초 안에 정답을 찾아내는 극한의 뇌지컬 테스트.",
    },
  },
  // ⭐️ [신규 추가] 아주 쉬운 덧셈, 뺄셈
  {
    path: "/easy-math",
    name: "EasyMathPage",
    component: () => import("../views/EasyMathPage.vue"),
    meta: {
      title: "아주 쉬운 덧셈, 뺄셈 - 말로만랩",
      description: "0.5초마다 지나가는 숫자들을 누적해서 암산하세요. 당신의 뇌지컬 한계를 시험하는 하드코어 플래시 암산 게임.",
    },
  },
  {
    path: "/auth-code",
    name: "AuthCodePage",
    component: () => import("../views/AuthCodePage.vue"),
    meta: {
      title: "인증번호를 외우고 싶어 - 말로만랩",
      description: "무작위 문자를 기억하고 맞히는 인간 캡챠 인증 테스트. 당신의 작업 기억력을 확인하세요.",
    },
  },

  // ⭐️ [신규] 시크릿 로또 페이지 추가 (routes 배열 안에 넣으세요)
  {
    path: "/secret-lotto",
    name: "SecretLottoPage",
    // 뷰 컴포넌트는 5번 단계에서 만들 예정입니다.
    component: () => import("../views/SecretLottoPage.vue"),
    meta: {
      title: "시크릿 랩 - 말로만랩",
      requiresAuth: true
    },
    // ⭐️ 접속 전 권한 체크 (핵심)
    beforeEnter: (to, from, next) => {
      const authStore = useAuthStore();
      
      // 스토어에 권한이 없으면 홈으로 튕겨냄
      if (!authStore.allowLotto) {
        alert("접근 권한이 없는 구역입니다. 관리자에게 문의하세요.");
        next("/");
      } else {
        next();
      }
    }
  },

  // 4. 지원 (Support) 및 설정
  {
    path: "/partnership",
    name: "PartnershipPage",
    component: () => import("../views/PartnershipPage.vue"),
    meta: {
      title: "제휴 문의 - 말로만랩",
      description:
        "교육, 마케팅, 데이터 등 말로만랩의 독창적인 콘텐츠와 기술력을 귀사의 비즈니스에 접목해보세요.",
    },
  },
  {
    path: "/devinquiry",
    name: "DevInquiryPage",
    component: () => import("../views/DevInquiryPage.vue"),
    meta: {
      title: "개발 문의 - 말로만랩",
      description:
        "아이디어를 현실로. 21년 차 풀스택 전문가와 함께 웹/앱 서비스부터 MVP까지 성공적인 프로젝트를 만드세요.",
    },
  },
  {
    path: "/settings",
    name: "SettingsPage",
    component: () => import("../views/SettingsPage.vue"),
    meta: {
      title: "설정 - 말로만랩",
      description: "계정 관리 및 서비스 설정을 변경할 수 있습니다.",
    },
  },
  {
    path: "/settings/nickname",
    name: "NicknameChangePage",
    component: () => import("../views/NicknameChangePage.vue"),
    meta: { title: "닉네임 변경 - 말로만랩" },
  },
  {
    path: "/settings/password",
    name: "PasswordChangePage",
    component: () => import("../views/PasswordChangePage.vue"),
    meta: { title: "비밀번호 변경 - 말로만랩" },
  },
  {
    path: "/settings/deactivate", // ⭐️ 회원 탈퇴 경로
    name: "DeactivatePage",
    component: () => import("../views/DeactivatePage.vue"),
    meta: {
      title: "회원 탈퇴 - 말로만랩",
      requiresAuth: true,
    },
  },

  // 5. 고객센터 (공지사항, QnA)
  {
    path: "/notice",
    name: "NoticeListPage",
    component: () => import("../views/NoticeListPage.vue"),
    meta: { title: "공지사항 - 말로만랩", description: "말로만랩의 새로운 소식과 업데이트를 확인하세요." },
  },
  {
    path: "/notice/:id",
    name: "NoticeDetailPage",
    component: () => import("../views/NoticeDetailPage.vue"),
    meta: { title: "공지사항 상세 - 말로만랩" },
  },
  {
    path: "/qna",
    name: "QnaPage",
    component: () => import("../views/QnaPage.vue"),
    meta: { title: "문의하기 - 말로만랩", description: "궁금한 점이나 제안할 내용을 남겨주세요." },
  },

  // 6. 회원 관련 (인증, 에너지)
  {
    path: "/login",
    name: "LoginPage",
    component: () => import("../views/LoginPage.vue"),
    meta: { title: "로그인 - 말로만랩" },
  },
  {
    path: "/register",
    name: "RegisterPage",
    component: () => import("../views/RegisterPage.vue"),
    meta: { title: "회원가입 - 말로만랩" },
  },
  {
    path: "/forgot-password",
    name: "ForgotPasswordPage",
    component: () => import("../views/ForgotPasswordPage.vue"),
    meta: { title: "비밀번호 찾기 - 말로만랩" },
  },
  {
    path: "/energy-history",
    name: "EnergyHistoryPage",
    component: () => import("../views/EnergyHistoryPage.vue"),
    meta: { title: "에너지 내역 - 말로만랩" },
  },

  // 기타 레거시 또는 리다이렉트
  {
    path: "/quiz-redirect",
    name: "QuizRedirectPage",
    component: () => import("../views/QuizRedirectPage.vue"),
    meta: { title: "퀴즈 - 말로만랩" },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

router.afterEach((to) => {
  setTimeout(() => {
    if (to.meta.title) {
      updateMetaTags(to.meta.title, to.meta.description || "");
    }
  }, 0);
});

export default router;
